import coerceToString from 'helper/string/coerce_to_string';

/**
 * Returns the last occurrence index of `search` in `subject`.
 *
 * @function lastIndexOf
 * @static
 * @since 1.0.0
 * @memberOf Index
 * @param {string} [subject=''] The string where to search.
 * @param {string} search The string to search.
 * @param {number} [fromIndex=subject.length - 1] The index to start searching backward in the string.
 * @return {number} Returns the last occurrence index or `-1` if not found.
 * @example
 * as.lastIndexOf('morning', 'n');
 * // => 5
 *
 * as.lastIndexOf('evening', 'o');
 * // => -1
 */
export default function lastIndexOf(subject, search, fromIndex) {
  const subjectString = coerceToString(subject);
  return subjectString.lastIndexOf(search, fromIndex);
}